import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column h-100 justify-space-between" }

import { computed, ref, onBeforeUnmount } from 'vue';
import CardData, { ICardItem } from './CardData.vue';

interface CardDataProps {
  activity: string;
  location: string;
  client?: string;
  priority?: number;
  rating?: number;
  requestTimestamp?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MoleculeTimeCard',
  props: {
    data: {},
    type: {}
  },
  setup(__props: any) {

const props = __props;

const elapsedTime = ref('');
let timer: number | undefined;

const getElapsedTime = (requestTime: string): string => {
  const now = new Date();
  const request = new Date(requestTime);
  const elapsed = now.getTime() - request.getTime();

  const totalSeconds = Math.floor(elapsed / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
};


const updateElapsedTime = () => {
  if (props.data.requestTimestamp) {
    elapsedTime.value = getElapsedTime(props.data.requestTimestamp);
  }
}

if (props.data.requestTimestamp) {
  elapsedTime.value = getElapsedTime(props.data.requestTimestamp);
}

updateElapsedTime();
timer = window.setInterval(updateElapsedTime, 1000);

onBeforeUnmount(() => {
  clearInterval(timer);
});

const cardTopRow = computed(() => [
  { title: 'Serviço', subtitle: props.data.activity },
]);

const cardBottomRow = computed(() => {
  const items: ICardItem[] = [{ title: 'Localização', subtitle: props.data.location }];
  if (props.type === 'sla') {
    items.push({ title: 'Prioridade', subtitle: props.data.priority, type: 'priority' });
  } else if (props.type === 'unhappy') {
    items.push({ title: 'Avaliação', subtitle: props.data.rating, type: 'rating' });
  }
  return items;
});

return (_ctx: any,_cache: any) => {
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    class: "mx-0 bg d-flex flex-column pa-7",
    height: "190",
    variant: "outlined"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(CardData, {
          items: cardTopRow.value,
          hours: elapsedTime.value,
          type: _ctx.type
        }, null, 8, ["items", "hours", "type"]),
        _createVNode(CardData, { items: cardBottomRow.value }, null, 8, ["items"])
      ])
    ]),
    _: 1
  }))
}
}

})